<template>
    <tr class="tw-border-b tw-border-solid tw-border-gray-100 last:tw-border-b-0 tw-group hover:tw-bg-gray-50/50 tw-transition-colors tw-duration-200">
        <!-- ID -->
        <td v-if="false" class="tw-px-4 tw-py-3 tw-text-sm tw-text-gray-900 tw-font-medium">
            #{{ item.id }}
        </td>

        <!-- Name -->
        <td class="tw-px-4 tw-py-3">
            <div class="tw-text-sm tw-font-medium tw-text-gray-900 tw-truncate tw-max-w-[200px]" :title="item.name">
                {{ item.name }}
            </div>
        </td>

        <!-- Description -->
        <td class="tw-px-4 tw-py-3">
            <div class="tw-text-sm tw-text-gray-600 tw-truncate tw-max-w-[250px]" :title="item.description">
                {{ item.description || $t('common.no-description', 'No description') }}
            </div>
        </td>

        <!-- Type -->
        <td class="tw-px-4 tw-py-3">
            <span 
                v-if="displayType"
                class="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-2.5 tw-py-1 tw-rounded-md tw-text-xs tw-font-medium tw-transition-colors tw-duration-200"
                :class="getTypeStyles(displayType.id)"
            >
                <icon :icon="displayType.icon" class="tw-w-3.5 tw-h-3.5" />
                {{ displayType.label }}
            </span>
            <span v-else class="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-2.5 tw-py-1 tw-rounded-md tw-text-xs tw-font-medium tw-bg-gray-50 tw-text-gray-500">
                <icon icon="solar:question-circle-linear" class="tw-w-3.5 tw-h-3.5" />
                {{ $t('common.not-specified', 'Not specified') }}
            </span>
        </td>

        <!-- Created At -->
        <td class="tw-px-4 tw-py-3 tw-text-sm tw-text-gray-500">
            {{ formatDate(item.created_at) }}
        </td>

        <!-- Actions -->
        <td class="tw-px-4 tw-py-3">
            <CertificateTableActions 
                :item="item"
                @edit="$emit('edit', item)"
                @delete="$emit('delete', item)"
            />
        </td>
    </tr>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import CertificateTableActions from './CertificateTableActions.vue';

const { t } = useI18n();

const props = defineProps({
    item: {
        type: Object,
        required: true
    }
});

defineEmits(['edit', 'delete']);

// Type options matching the modals structure
const typeOptions = [
    { id: 'product', label: t('common.product', 'Product'), icon: 'solar:box-bold-duotone' },
    { id: 'service', label: t('common.service', 'Service'), icon: 'solar:settings-bold-duotone' },
    { id: 'company', label: t('common.company', 'Company'), icon: 'solar:buildings-bold-duotone' },
    { id: 'general', label: t('common.general', 'General'), icon: 'solar:widget-bold-duotone' }
];

// Computed property to get the display type
const displayType = computed(() => {
    if (!props.item.type) return null;
    return typeOptions.find(option => option.id === props.item.type) || null;
});

// Helper function to get type-specific styles
const getTypeStyles = (typeId) => {
    const styles = {
        product: 'tw-bg-blue-50 tw-text-blue-700 hover:tw-bg-blue-100',
        service: 'tw-bg-green-50 tw-text-green-700 hover:tw-bg-green-100',
        company: 'tw-bg-purple-50 tw-text-purple-700 hover:tw-bg-purple-100',
        general: 'tw-bg-gray-50 tw-text-gray-700 hover:tw-bg-gray-100'
    };
    return styles[typeId] || 'tw-bg-gray-50 tw-text-gray-500';
};

const formatDate = (dateString) => {
    if (!dateString) return '-';
    
    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    } catch (error) {
        return dateString;
    }
};
</script>

<style scoped>
/* Add any custom styles here */
</style> 